import {Component, OnInit, Inject, OnDestroy, ViewChild, HostListener} from '@angular/core';
import {Subscription} from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {DialogService} from '@rbaip/ui-component';
import {OpportunityContractSearchDto} from '../../shared/opportunity/opportunity-contract-search-dto';
import { Opportunity, OpportunityContract, OpportunityContractLookupType, OpportunityStage} from '../../shared/domain/opportunity';
import {ItemSummaryOpportunityService} from '../../shared/opportunity/item-summary-opportunity.service';
import {COLUMNS_AS_ARRAY} from './contract-opp-search-table/contract-opp-search-table-settings';
import {ContractStatus} from '../../shared/domain/contract';
import {assetMessage} from '../../shared/domain/item';
import {DataTableComponent, ColHeaderTypeEnum, FilterTypeEnum} from "@rbaip/data-table-v2";
import {appConfig} from "../../shared/app.config";

@Component({
  selector: 'lib-item-summary-lookup-contract-opportunity-advanced',
  templateUrl: './lookup-contract-opportunity-advanced.component.html',
  styleUrls: ['./lookup-contract-opportunity-advanced.component.scss']
})
export class LookupContractOpportunityAdvancedComponent implements OnInit, OnDestroy {

  public opportunityContractSearchDto: OpportunityContractSearchDto = new OpportunityContractSearchDto();
  public lookupType: string;
  public OpportunityContractLookupType = OpportunityContractLookupType;
  public contracts: OpportunityContract[];

  readonly columnsToShow: string[];
  readonly pageSizeOptions = [25, 50, 100];
  readonly pageSize = 25;
  readonly ColHeaderTypeEnum = ColHeaderTypeEnum;
  FilterTypeEnum = FilterTypeEnum;
  public searchAttempted = false;
  public dateFormat = appConfig.dateFormat;
  width: number;
  height: number;
  currentOpportunity: Opportunity;

  private contractSearchParamControlSubscription: Subscription;
  private opportunitySearchParamControlSubscription: Subscription;

  @ViewChild('table') table: DataTableComponent;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any,
              private dialogRef: MatDialogRef<LookupContractOpportunityAdvancedComponent>,
              private opportunityService: ItemSummaryOpportunityService,
              private dialogService: DialogService) {
    this.columnsToShow = COLUMNS_AS_ARRAY.map(col => col.field);
    this.lookupType = this.data.lookupType;
    this.currentOpportunity = this.data.currentOpportunity;
  }

  ngOnInit() {
    setInterval(() => {
      this.calculateWidthAndHeight();
    }, 1000, 5000);
  }

  ngOnDestroy() {
    if (this.contractSearchParamControlSubscription) {
      this.contractSearchParamControlSubscription.unsubscribe();
    }
    if (this.opportunitySearchParamControlSubscription) {
      this.opportunitySearchParamControlSubscription.unsubscribe();
    }
  }

  public search(): void {
    if (!this.opportunityContractSearchDto.contractNumber && !this.opportunityContractSearchDto.opportunityName &&
      !this.opportunityContractSearchDto.legalName && !this.opportunityContractSearchDto.firstName && !this.opportunityContractSearchDto.lastName) {
      return;
    }
    this.dialogService.showProgress();
    this.searchAttempted = true;
    if (this.lookupType === OpportunityContractLookupType.Opportunity) {
      this.searchOpportunities();
    } else {
      this.searchContracts();
    }
  }

  public getContractStageColor(contractStage: string): string {
    return ContractStatus.getContractStageColor(contractStage);
  }

  public getOpportunityStageColor(opportunityStage: string): string {
    return OpportunityStage.getOpportunityStageColor(opportunityStage);
  }

  public onSelection(opportunityContract: OpportunityContract) {
    if (this.lookupType === OpportunityContractLookupType.Contract && !opportunityContract.ipContractId) {
      this.dialogService.showMessageDialog(assetMessage.contractMoveOppWithNoContractError);
      return;
    }
    this.dialogRef.close(opportunityContract);
  }

  private searchContracts(): void {
    this.contractSearchParamControlSubscription = this.opportunityService.loadContractsBySearchParameters(this.opportunityContractSearchDto).subscribe(
      contracts => {
        this.dialogService.hideProgress();
        if (!!contracts) {
          this.contracts = contracts;
          this.removeCurrentOpportunityContractFromSearchList();
          this.table.setData(this.contracts);
          this.table.setDataLoadingInProgress(false);
        }
      });
  }

  private searchOpportunities(): void {
    this.opportunitySearchParamControlSubscription = this.opportunityService.loadOpportunitiesBySearchParameters(this.opportunityContractSearchDto).subscribe(
      contracts => {
        this.dialogService.hideProgress();
        if (!!contracts) {
          this.contracts = contracts;
          this.removeCurrentOpportunityContractFromSearchList();
          this.table.setData(this.contracts);
          this.table.setDataLoadingInProgress(false);
        }
      });
  }

  @HostListener('window:resize', ['$event'])
  onResize(e) {
    this.calculateWidthAndHeight();
  }

  private calculateWidthAndHeight(): void {
    const dom = document.querySelector('#custom-table-container') as HTMLDivElement;
    const offSetTop = dom ? dom.getBoundingClientRect().top + window.scrollY : 50;
    const offSetLeft = dom ? dom.getBoundingClientRect().left + window.scrollX : 50;
    this.height = window.innerHeight - offSetTop - 50;
    this.width = window.innerWidth - offSetLeft - 10;
  }

  /**
   * This method purpose is not to show the same opportunity/same contract(Source) in the search list when we try to move any asset.
   */
  private removeCurrentOpportunityContractFromSearchList() {
    if (!!this.currentOpportunity) {
      this.contracts = this.contracts.filter(opportunityContract => {
        return opportunityContract.salesHubContractNumber !== this.currentOpportunity.contractNumber || opportunityContract.opportunityId !== this.currentOpportunity.ipOpportunityId;
      })
    }
  }
}
